document.addEventListener('alpine:init', () => {
  Alpine.data('QuantityStepper', () => {
    return {
      quantity: 6, // Changed this to start the quantity from 6.
      init() {
        const preset = parseInt(this.$el.dataset.defaultQty, 10);
        if (!Number.isNaN(preset)) {
          this.quantity = preset;
        }
        if (this.dropdownQuantity) {
          if (this.dropdownQuantity === '10+') {
            this.quantity = 10;
          } else {
            this.quantity = parseInt(this.dropdownQuantity, 10);
          }
        }
      },
      dispatchInputChange() {
        this.$refs.quantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      },
      decreaseQuantity() {
        this.quantity > 1 && this.quantity--;
        this.dispatchInputChange();
      },
      increaseQuantity() {
        this.quantity++;
        this.dispatchInputChange();
      },
    };
  });
});
